import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { rfiSectionClient } from '../rfiSectionHooks';
/** WRT-06: the RFI Home read model (`GetRfiWorkspaceHome`). */ export const RFI_HOME_KEY = 'rfi-workspace-home';
export function useRfiWorkspaceHome(rfiResponseProjectId) {
    return useQuery({
        queryKey: [
            RFI_HOME_KEY,
            rfiResponseProjectId
        ],
        enabled: Boolean(rfiResponseProjectId),
        staleTime: 15000,
        queryFn: ()=>rfiSectionClient.getRfiWorkspaceHome({
                rfiResponseProjectId
            })
    });
}
function useInvalidateHome(rfiResponseProjectId) {
    const qc = useQueryClient();
    return ()=>Promise.all([
            qc.invalidateQueries({
                queryKey: [
                    RFI_HOME_KEY,
                    rfiResponseProjectId
                ]
            }),
            qc.invalidateQueries({
                queryKey: [
                    'rfi-nav-counts',
                    rfiResponseProjectId
                ]
            })
        ]);
}
export function useUpdateRfiSubmissionFacts(rfiResponseProjectId) {
    const invalidate = useInvalidateHome(rfiResponseProjectId);
    return useMutation({
        mutationFn: (req)=>rfiSectionClient.updateRfiSubmissionFacts({
                ...req,
                rfiResponseProjectId
            }),
        onSuccess: invalidate
    });
}
export function useCreateRfiSignal(rfiResponseProjectId) {
    const invalidate = useInvalidateHome(rfiResponseProjectId);
    return useMutation({
        mutationFn: (req)=>rfiSectionClient.createRfiSignal({
                kind: 'manual',
                source: 'user',
                ...req,
                rfiResponseProjectId
            }),
        onSuccess: invalidate
    });
}
export function useRetractRfiSignal(rfiResponseProjectId) {
    const invalidate = useInvalidateHome(rfiResponseProjectId);
    return useMutation({
        mutationFn: (signalId)=>rfiSectionClient.retractRfiSignal({
                rfiResponseProjectId,
                signalId
            }),
        onSuccess: invalidate
    });
}
export function useLinkRfiEntity(rfiResponseProjectId) {
    const invalidate = useInvalidateHome(rfiResponseProjectId);
    return useMutation({
        mutationFn: (req)=>rfiSectionClient.linkRfiEntity({
                ...req,
                rfiResponseProjectId
            }),
        onSuccess: invalidate
    });
}
export function useConfirmRfiEntity(rfiResponseProjectId) {
    const invalidate = useInvalidateHome(rfiResponseProjectId);
    return useMutation({
        mutationFn: (req)=>rfiSectionClient.confirmRfiEntity({
                ...req,
                rfiResponseProjectId
            }),
        onSuccess: invalidate
    });
}
export function useUnlinkRfiEntity(rfiResponseProjectId) {
    const invalidate = useInvalidateHome(rfiResponseProjectId);
    return useMutation({
        mutationFn: (linkId)=>rfiSectionClient.unlinkRfiEntity({
                rfiResponseProjectId,
                linkId
            }),
        onSuccess: invalidate
    });
}
